import IReservation from "@/interfaces/IReservation";
import moment from 'moment';

let isOnSameDay = (start: string|Date, end: string|Date): boolean => {
	if (start && end) {
		let startDate: Date = new Date(start);
		let endDate: Date = new Date(end);
		endDate.setSeconds(endDate.getSeconds() - 1); // -1 to check for 24:00 endings
		if (startDate.toDateString() === endDate.toDateString()) {
			return true;
		}
	}
	return false;
}

let isEndOfDay = (end: string|Date): boolean => {
	if (end) {
		let endDate: Date = new Date(end);
		if (endDate.getHours() === 0 && endDate.getMinutes() === 0) {
			return true;
		}
	}
	return false;
}

let isReservationOnSameDay = (reservation: IReservation | null): boolean => {
	if (reservation !== null) {
		return reservation.is_recurring || isOnSameDay(reservation.start, reservation.end)
	}
	return false;
}

let formattedHours = (start: string|Date): string => {
	if (start) {
		let date = new Date(start)
		return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
	}
	return '';
}

let formattedEndHours = (end: string|Date): string => {
	if (end) {
		let endDate = new Date(end)
		if (endDate.getHours() === 0 && endDate.getMinutes() === 0) {
			return '24:00';
		}
		return endDate.getHours() + ':' + (endDate.getMinutes() < 10 ? '0' : '') + endDate.getMinutes();
	}
	return '';
}

let formattedDate = (start: string|Date, format: string = 'dddd DD.MM.YY, HH:mm'): string => {
	if (start) {
		let date = new Date(start)
		return moment(date).format(format);
	}
	return '';
}

let formattedEndDate = (end: string|Date, format: string = 'dd DD.MM.YY'): string => {
	if (end) {
		let endDate = new Date(end)
		if (endDate.getHours() === 0 && endDate.getMinutes() === 0) {
			endDate.setDate(endDate.getDate() - 1);
		}
		return moment(endDate).format(format);
	}
	return '';
}

let formattedEndDateHours = (end: string|Date, format: string = 'dddd DD.MM.YY'): string => {
	if (end) {
		let endDate = new Date(end)
		let hours: string;
		if (endDate.getHours() === 0 && endDate.getMinutes() === 0) {
			hours = '24:00';
			endDate.setDate(endDate.getDate() - 1);
		} else {
			hours = endDate.getHours() + ':' + (endDate.getMinutes() < 10 ? '0' : '') + endDate.getMinutes();
		}
		return moment(endDate).format(format) + ', ' + hours;
	}
	return '';
}

let formatDateAsISO = (date: Date | null): string => {
	if (date) {
		return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${addZero(date.getHours())}:${addZero(date.getMinutes())}`
	}
	return '';
}

let formattedMonthName = (start: string|Date): string => {
	if (start) {
		let startDate: Date = new Date(start);
		let months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
		return months[startDate.getMonth()];
	}
	return '';
}
let formattedWeekdayName = (start: string|Date): string => {
	if (start) {
		let startDate: Date = new Date(start);
		let weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
		return weekdays[startDate.getDay()];
	}
	return '';
}

let addZero = (i: number): string => {
	if (i < 10) {
		return "0" + i;
	}
	return String(i);
}

export default {
	isOnSameDay,
	isEndOfDay,
	isReservationOnSameDay,
	formattedHours,
	formattedEndHours,
	formattedDate,
	formattedEndDate,
	formattedEndDateHours,
	formatDateAsISO,
	formattedMonthName,
	formattedWeekdayName,
	addZero,
}
